import { Diamond, Star } from 'lucide-react'
import { RATING_COLORS } from '@/lib/rating-colors'

type Props = {
  rating: number
  size?: number
}

export default function AiRatingStars({ rating, size = 16 }: Props) {
  if (rating > 5) {
    const filledCount = rating - 5
    return (
      <div className="flex gap-0.5">
        {[1, 2, 3, 4, 5].map((n) => (
          <Diamond
            key={n}
            size={size}
            className={n <= filledCount ? RATING_COLORS.aiDiamond : RATING_COLORS.empty}
          />
        ))}
      </div>
    )
  }

  return (
    <div className="flex gap-0.5">
      {[1, 2, 3, 4, 5].map((n) => (
        <Star
          key={n}
          size={size}
          className={n <= rating ? RATING_COLORS.aiStar : RATING_COLORS.empty}
        />
      ))}
    </div>
  )
}
